@import '../../../../constants/spacing.module.less';

.weight-inputs-outer-container {
  display: grid;
  grid-column: span 2;
  grid-template-columns: subgrid;
}

.weight-inputs-inner-container {
  display: grid;
  grid-column: span 2;
  grid-template-columns: subgrid;
}

.weight-field {
  display: grid;
  grid-template-rows: auto 1fr;
}

.weight {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}

.scale-button {
  padding: @space-4 @space-12;
  gap: @space-8;
  color: var(--default--text-color--10);

  &:disabled {
    color: var(--default--text-color--14);
  }
}

.scale-icon {
  padding: 0;
  height: 20px;
  width: 20px;
  fill: var(--default--icon--fill-color--12);
}
